export const SETTINGS_LIST_REQUEST = "SETTINGS_LIST_REQUEST";
export const SETTINGS_LIST_SUCCESS = "SETTINGS_LIST_SUCCESS";
export const SETTINGS_LIST_FAIL = "SETTINGS_LIST_FAIL";

export const SETTINGS_UPDATE_REQUEST = "SETTINGS_UPDATE_REQUEST";
export const SETTINGS_UPDATE_SUCCESS = "SETTINGS_UPDATE_SUCCESS";
export const SETTINGS_UPDATE_FAIL = "SETTINGS_UPDATE_FAIL";
